import { db } from "../firebase";
import { collection, query, where, getDocs } from "firebase/firestore";
import { store } from "../store/store";

export default async function getDatabase(auth) {
  try {
    // Create a query to find the document where the email matches the authenticated user's email
    const q = query(collection(db, "clientes"), where("email", "==", auth.email));
    // Execute the query
    const querySnapshot = await getDocs(q);
    if (querySnapshot.empty) {
      console.log("No matching documents.");
      return null; // Or handle the case where no document matches
    }

    // Assuming there is only one document matching the query
    const userData = querySnapshot.docs[0].data();

    // Commit the found user data to the store
    store.commit("incrementDatabase", userData);

    return new Promise((resolve) => {
      resolve(userData);
    });
  } catch (error) {
    console.error("Error getting user data: ", error);
    return null; // Or handle the error appropriately
  }
}
